import React, { useEffect, useRef, useState } from 'react';

export default function Footer() {
  const sectionRef = useRef<HTMLElement>(null);
  const [isInView, setIsInView] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you for subscribing!');
    setEmail('');
  };

  return (
    <footer
      ref={sectionRef}
      className="relative bg-[var(--vyera-black)] text-[var(--vyera-cream)]"
      style={{ zIndex: 70 }}
    >
      {/* Top Divider */}
      <div className="hairline-light" />

      {/* Main Content */}
      <div className="px-5 sm:px-[6vw] py-12 sm:py-20 pb-[max(3rem,env(safe-area-inset-bottom))]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16">
          {/* Newsletter Block */}
          <div
            className={`transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
          >
            <h2 className="vyera-heading-md text-[var(--vyera-cream)] mb-4">
              Stay in rhythm.
            </h2>
            <p className="vyera-body text-[var(--vyera-text-secondary)] mb-8 max-w-sm">
              New drops, early access, and stories — sent sparingly.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="flex-1 min-h-[48px] bg-transparent border-b border-[var(--vyera-text-secondary)] text-[var(--vyera-cream)] py-3 px-0 focus:outline-none focus:border-[var(--vyera-burgundy)] transition-colors text-[16px] placeholder:text-[var(--vyera-warm-grey)]"
                required
              />
              <button
                type="submit"
                className="min-h-[48px] px-6 py-3 border border-[var(--vyera-cream)]/40 text-[var(--vyera-cream)] text-[13px] font-medium tracking-wide hover:bg-[var(--vyera-cream)]/10 transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>

          {/* Contact Block */}
          <div
            className={`lg:text-right transition-all duration-700 delay-100 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
          >
            <div className="mb-8">
              <p className="vyera-label text-[var(--vyera-text-secondary)] mb-2">
                Press & partnerships
              </p>
              <a
                href="mailto:press@vyera.studio"
                className="inline-block min-h-[44px] py-2 text-[var(--vyera-cream)] hover:text-[var(--vyera-burgundy)] transition-colors text-[15px]"
              >
                press@vyera.studio
              </a>
            </div>

            <div>
              <p className="vyera-label text-[var(--vyera-text-secondary)] mb-2">
                Support
              </p>
              <a
                href="mailto:help@vyera.studio"
                className="inline-block min-h-[44px] py-2 text-[var(--vyera-cream)] hover:text-[var(--vyera-burgundy)] transition-colors text-[15px]"
              >
                help@vyera.studio
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Row */}
      <div
        className={`px-5 sm:px-[6vw] py-6 sm:py-8 border-t border-[var(--vyera-warm-grey)]/20 transition-all duration-700 delay-200 ${isInView ? 'opacity-100' : 'opacity-0'
          }`}
      >
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Logo */}
          <div className="text-[18px] font-light tracking-[0.2em] text-[var(--vyera-cream)]">
            VYERA
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center md:justify-end gap-6 sm:gap-8">
            <a href="#" className="min-h-[44px] flex items-center text-[13px] text-[var(--vyera-text-secondary)] hover:text-[var(--vyera-cream)] transition-colors">
              Instagram
            </a>
            <a href="#" className="min-h-[44px] flex items-center text-[13px] text-[var(--vyera-text-secondary)] hover:text-[var(--vyera-cream)] transition-colors">
              Pinterest
            </a>
            <a href="#" className="min-h-[44px] flex items-center text-[13px] text-[var(--vyera-text-secondary)] hover:text-[var(--vyera-cream)] transition-colors">
              Privacy
            </a>
            <a href="#" className="min-h-[44px] flex items-center text-[13px] text-[var(--vyera-text-secondary)] hover:text-[var(--vyera-cream)] transition-colors">
              Terms
            </a>
          </div>

          {/* Copyright */}
          <div className="text-[12px] text-[var(--vyera-text-secondary)]">
            © 2026 VYERA
          </div>
        </div>
      </div>
    </footer>
  );
}
